export default __webpack_public_path__ + "static/media/009-sagrada familia.f3e9cec6.svg";